var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _path2, _rect117, _path3, _path4, _path5, _path6, _path7, _path8, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _path9, _rect145, _path10, _path11, _path12, _path13, _path14, _path15, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAiGoose = function SvgAiGoose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 66.4287,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 57.499,
    width: 7.14286,
    height: 14.6429,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 62.8564,
    width: 57.1429,
    height: 8.92857,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2144,
    y: 57.499,
    width: 32.1429,
    height: 8.92857,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 53.9287,
    width: 42.8571,
    height: 9.28572,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1426 45H36.0711V48.5719H28.9282L28.9282 52.1429H19.9996V61.0718H14.6426V71.786H21.7855V73.5718H60.1784V71.786H71.7854V66.4289H75.3568V55.7146H69.9996V48.5719H52.1426V45Z",
    fill: "#19FBFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 50.3564,
    width: 17.8571,
    height: 9.28572,
    fill: "#19FBFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 11.0713,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0713,
    y: 43.2139,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 46.7861,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 59.2861,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 57.499,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 70,
    width: 7.14286,
    height: 1.78571,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 77.1426,
    width: 46.4286,
    height: 1.78571,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 50.3564,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 21.7861,
    width: 8.92857,
    height: 1.78571,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 28.9287,
    width: 12.5,
    height: 1.78571,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 12.8564,
    width: 1.78571,
    height: 6.25,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2856,
    y: 44.999,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 71.7861,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8569,
    y: 61.0713,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 19.1064,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 18.2139,
    width: 1.78571,
    height: 28.5714,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 30.7139,
    width: 1.78571,
    height: 21.4286,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 50.3564,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 55.7139,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 61.0713,
    width: 32.1429,
    height: 1.78571,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 52.1426,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 53.9287,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 66.4287,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3569,
    y: 55.7139,
    width: 1.78571,
    height: 10.7143,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 52.1426,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 66.4287,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7144,
    y: 23.5713,
    width: 1.78571,
    height: 7.14286,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 17.3213,
    width: 16.0714,
    height: 31.25,
    fill: "#19FBFF"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 33.3926,
    width: 7.14286,
    height: 1.78571,
    fill: "black"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 30.7139,
    width: 17.8571,
    height: 1.78571,
    fill: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 30.7139,
    width: 17.8571,
    height: 1.78571,
    fill: "black"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 38.5713,
    width: 1.42857,
    height: 1.42857,
    fill: "black"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 36.0713,
    width: 1.42857,
    height: 1.42857,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 41.0713,
    width: 1.42857,
    height: 1.42857,
    fill: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4644,
    y: 57.499,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4644,
    y: 53.9287,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 68.2139,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 64.6436,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 43.2139,
    width: 7.14286,
    height: 1.78571,
    fill: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 43.2139,
    width: 8.03572,
    height: 1.78571,
    transform: "rotate(-90 59.2856 43.2139)",
    fill: "black"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 13.75,
    width: 14.2857,
    height: 10.7143,
    fill: "#302E2E"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 23.5713,
    width: 16.0714,
    height: 7.14286,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 24.6426,
    width: 1.42857,
    height: 1.42857,
    fill: "black"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 27.6787,
    width: 1.42857,
    height: 1.42857,
    fill: "black"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 12.8564,
    width: 14.2857,
    height: 10.7143,
    fill: "#19FBFF"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 21.7861,
    width: 17.8571,
    height: 1.78571,
    fill: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 23.5713,
    width: 14.2857,
    height: 5.35714,
    fill: "black"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 23.5713,
    width: 14.2857,
    height: 5.35714,
    fill: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 72.6787,
    y: 23.5713,
    width: 5.35714,
    height: 2.14286,
    fill: "#ACACAC"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 12.8564,
    width: 5.35714,
    height: 2.14286,
    fill: "#D1FEFF"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 19.1064,
    width: 10.7143,
    height: 7.14286,
    fill: "#19FBFF"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7144,
    y: 24.4639,
    width: 5.71429,
    height: 1.78571,
    fill: "black"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 26.25,
    width: 2.67857,
    height: 1.78571,
    transform: "rotate(-90 59.2856 26.25)",
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 18.2139,
    width: 3.57143,
    height: 5.35714,
    fill: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 18.2139,
    width: 1.78571,
    height: 1.78571,
    fill: "white"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 48.5713,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 62.8564,
    width: 8.92857,
    height: 3.57143,
    fill: "#FFFEFD"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 71.7861,
    width: 8.92857,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 68.2139,
    width: 1.78571,
    height: 3.57143,
    fill: "#FFFEFD"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 71.7861,
    width: 46.4286,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 59.2861,
    width: 30.3571,
    height: 1.78571,
    fill: "#009B9E"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1431,
    y: 48.5713,
    width: 1.78571,
    height: 13.3929,
    fill: "black"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 71.7861,
    width: 33.9286,
    height: 1.78571,
    fill: "#009B9E"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 71.7861,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 75.3564,
    width: 46.4286,
    height: 1.78571,
    fill: "#BABABA"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 73.5713,
    width: 46.4286,
    height: 1.78571,
    fill: "#EAEAEA"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 61.0713,
    width: 1.78571,
    height: 10.7143,
    fill: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 61.0713,
    width: 1.78571,
    height: 16.0714,
    fill: "black"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7144,
    y: 61.0713,
    width: 1.78571,
    height: 16.0714,
    fill: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 70,
    width: 7.14286,
    height: 1.78571,
    fill: "#009B9E"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 61.0713,
    width: 7.14286,
    height: 1.78571,
    fill: "#009B9E"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0713,
    y: 66.4287,
    width: 1.78571,
    height: 3.57143,
    fill: "#009B9E"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 55.7139,
    width: 1.78571,
    height: 3.57143,
    fill: "#009B9E"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 52.1426,
    width: 1.78571,
    height: 3.57143,
    fill: "#009B9E"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52.1426,
    width: 3.57143,
    height: 5.35714,
    fill: "#009B9E"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 57.499,
    width: 1.78571,
    height: 3.57143,
    fill: "#009B9E"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 46.7861,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 64.6436,
    width: 5.35714,
    height: 5.35714,
    fill: "#009B9E"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 64.6436,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 68.2139,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 12.8564,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 73.5713,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 66.4287,
    width: 7.14286,
    height: 5.35714,
    fill: "#FFFEFD"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 71.7861,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 71.7861,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 62.8564,
    width: 3.57143,
    height: 1.78571,
    transform: "rotate(90 68.2144 62.8564)",
    fill: "#009B9E"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 66.4287,
    width: 3.57143,
    height: 1.78571,
    fill: "#009B9E"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 52.1426,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 55.7139,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4287,
    y: 57.499,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0713,
    y: 44.999,
    width: 14.2857,
    height: 1.78571,
    fill: "#D1FEFF"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 48.5713,
    width: 7.14286,
    height: 1.78571,
    fill: "#D1FEFF"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 52.1426,
    width: 5.35714,
    height: 1.78571,
    fill: "#D1FEFF"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55.7139,
    width: 1.78571,
    height: 1.78571,
    fill: "#D1FEFF"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 57.499,
    width: 1.78571,
    height: 1.78571,
    fill: "#D1FEFF"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7686,
    y: 24.752,
    width: 1.48352,
    height: 2.96703,
    fill: "black"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2852,
    y: 27.7197,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8018,
    y: 29.2031,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8018,
    y: 32.1699,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2192,
    y: 33.6533,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7031,
    y: 32.1699,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7031,
    y: 29.2031,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2192,
    y: 27.7197,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2852,
    y: 33.6533,
    width: 1.48352,
    height: 1.48352,
    fill: "black"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7358,
    y: 35.1367,
    width: 1.48352,
    height: 2.96703,
    fill: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7686,
    y: 35.1367,
    width: 1.48352,
    height: 2.96703,
    fill: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2524,
    y: 21.7852,
    width: 1.48352,
    height: 2.96703,
    fill: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2524,
    y: 38.1035,
    width: 1.48352,
    height: 2.96703,
    fill: "black"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4282,
    y: 32.1699,
    width: 1.48352,
    height: 2.37363,
    transform: "rotate(-90 26.4282 32.1699)",
    fill: "black"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1865,
    y: 32.1699,
    width: 1.48352,
    height: 2.37363,
    transform: "rotate(-90 39.1865 32.1699)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7358 24.752H36.2194V27.719H34.7358V24.752Z",
    fill: "black"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2524,
    y: 24.752,
    width: 1.48352,
    height: 13.3516,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8018 32.1699V30.6864H39.1864V32.1699H28.8018Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2852 30.6865V29.203H37.7027V30.6865H30.2852Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.769 29.2031V27.7196H36.2196V29.2031H31.769Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2852 33.6533V32.1698H37.7027V33.6533H30.2852Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.769 35.1377V33.6542H36.2196V35.1377H31.769Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.769 35.1377V33.6542H36.2196V35.1377H31.769Z",
    fill: "white"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2524,
    y: 24.752,
    width: 1.48352,
    height: 2.96703,
    fill: "#19FBFF"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2524,
    y: 35.1377,
    width: 1.48352,
    height: 2.96703,
    fill: "#19FBFF"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 31.769,
    y: 27.7197,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7363,
    y: 27.7197,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2852,
    y: 29.2031,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8018,
    y: 30.6865,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 31.769,
    y: 33.6533,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2852,
    y: 32.1699,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2192,
    y: 32.1699,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7363,
    y: 33.6533,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7031,
    y: 30.6865,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2192,
    y: 29.2031,
    width: 1.48352,
    height: 1.48352,
    fill: "#19FBFF"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2524,
    y: 14.7881,
    width: 0.962885,
    height: 1.93062,
    fill: "black"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2891,
    y: 16.7188,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3262,
    y: 17.6836,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3262,
    y: 19.6143,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1406,
    y: 20.5801,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1035,
    y: 19.6143,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1035,
    y: 17.6836,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1406,
    y: 16.7188,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2891,
    y: 20.5801,
    width: 0.962885,
    height: 0.965309,
    fill: "black"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1777,
    y: 21.5449,
    width: 0.962885,
    height: 1.93062,
    fill: "black"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2524,
    y: 21.5449,
    width: 0.962885,
    height: 1.93062,
    fill: "black"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2153,
    y: 12.8574,
    width: 0.962885,
    height: 1.93062,
    fill: "black"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2153,
    y: 23.4756,
    width: 0.962885,
    height: 1.93062,
    fill: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7856,
    y: 19.6143,
    width: 0.965309,
    height: 1.54062,
    transform: "rotate(-90 36.7856 19.6143)",
    fill: "black"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0664,
    y: 19.6143,
    width: 0.965309,
    height: 1.54062,
    transform: "rotate(-90 45.0664 19.6143)",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1777 14.7881H43.1406V16.7187H42.1777V14.7881Z",
    fill: "black"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2148,
    y: 14.7881,
    width: 0.962885,
    height: 8.68778,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3262 19.6143V18.6489H45.0664V19.6143H38.3262Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2891 18.6494V17.6841H44.1035V18.6494H39.2891Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2524 17.6836V16.7183H43.1411V17.6836H40.2524Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2891 20.5791V19.6138H44.1035V20.5791H39.2891Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2524 21.5449V20.5796H43.1411V21.5449H40.2524Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2524 21.5449V20.5796H43.1411V21.5449H40.2524Z",
    fill: "white"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2148,
    y: 14.7881,
    width: 0.962885,
    height: 1.93062,
    fill: "#19FBFF"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2148,
    y: 21.5449,
    width: 0.962885,
    height: 1.93062,
    fill: "#19FBFF"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2524,
    y: 16.7178,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1777,
    y: 16.7178,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2891,
    y: 17.6836,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3262,
    y: 18.6494,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2524,
    y: 20.5791,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2891,
    y: 19.6143,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1406,
    y: 19.6143,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1777,
    y: 20.5791,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1035,
    y: 18.6494,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1406,
    y: 17.6836,
    width: 0.962885,
    height: 0.965309,
    fill: "#19FBFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAiGoose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aiGoose.631e48d5.svg";
export { ForwardRef as ReactComponent };